import {Storage} from "@/models/facade/Storage";
import {LocalStorageKeyEnum} from "@/models/enum/LocalStorageKeyEnum";

export const fetchConfig = async () => (await fetch('/config.json', {cache: 'no-cache'})).json();

export const config = Storage.local.get(LocalStorageKeyEnum.CONFIG) ? JSON.parse(Storage.local.get(LocalStorageKeyEnum.CONFIG)) : {};
